// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
// ./node_modules/react-dev-utils/webpackHotDevClient.js:60 add slashes: true

import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import theme from './theme';
import router from './router';

// ReactDOM.render(
//   <ThemeProvider theme={theme}>
//     {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
//     <CssBaseline />
//     <App />
//   </ThemeProvider>,
//   document.querySelector('#root')
// );

import { createRoot } from 'react-dom/client';

const routerData = createBrowserRouter(router, {
  basename: '/boardbook',
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    {/* <App /> */}
    <RouterProvider router={routerData} />
  </ThemeProvider>
);
